// 90 days in milliseconds
export const PASSWORD_EXPIRATION_TIME = 1000 * 60 * 60 * 24 * 90;
